import React, { useState } from 'react';
import ExternalBusinessOutlawModal from '../../providers/cards/SearchListing/ExternalBusinessOutlawModal';
import { ShiftProviderUser } from 'models';
import { useUserContext } from 'UserContext';
import Error from '../components/Error';
import { MainContainer } from '../components/Containers';
import ProviderWelcomeBack from './ProviderWelcomeBack';
import MainCopy from './MainCopy';
import MainButtons from './MainButtons';

const LowStarProviderReview = ({ provider }: { provider: ShiftProviderUser }) => {
    const { user } = useUserContext();

    const business = user?.businesses?.[0];
    const businessId = business?.id;

    const [banAction, setBanAction] = useState(false);
    const [selectedWelcomeBack, setSelectedWelcomeBack] = useState<boolean>(false);

    if (!businessId) {
        return <Error />;
    }

    if (selectedWelcomeBack) {
        return <ProviderWelcomeBack providerFirstName={provider.first_name} businessName={business.name} />;
    }

    return (
        <MainContainer>
            <MainCopy provider={provider} business={business} />
            <MainButtons
                onWelcomeBackClick={() => {
                    setSelectedWelcomeBack(true);
                }}
                onBanClick={() => {
                    setBanAction(true);
                }}
            />
            <ExternalBusinessOutlawModal
                open={banAction}
                onClose={() => {
                    setBanAction(false);
                }}
                user={provider}
                businessId={businessId}
                leaveFeedback={false}
            />
        </MainContainer>
    );
};

export default LowStarProviderReview;
